module.exports = __webpack_public_path__ + "static/media/id-card-alt.75652c13.svg";